// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/azureuser/aydentify-production/frontend/src/models/payment';
import model_2 from '/home/azureuser/aydentify-production/frontend/src/models/subscription';
import model_3 from '/home/azureuser/aydentify-production/frontend/src/pages/Company/Detail/model';
import model_4 from '/home/azureuser/aydentify-production/frontend/src/pages/Dashboard/model';
import model_5 from '/home/azureuser/aydentify-production/frontend/src/pages/List/model';
import model_6 from '/home/azureuser/aydentify-production/frontend/src/pages/Profile/model';
import model_7 from '/home/azureuser/aydentify-production/frontend/src/pages/Search/packaging/model';
import model_8 from '/home/azureuser/aydentify-production/frontend/src/pages/Search/people/model';
import model_9 from '/home/azureuser/aydentify-production/frontend/src/pages/Search/products/model';

export const models = {
model_1: { namespace: 'payment', model: model_1 },
model_2: { namespace: 'subscription', model: model_2 },
model_3: { namespace: 'Company.Detail.model', model: model_3 },
model_4: { namespace: 'Dashboard.model', model: model_4 },
model_5: { namespace: 'List.model', model: model_5 },
model_6: { namespace: 'Profile.model', model: model_6 },
model_7: { namespace: 'Search.packaging.model', model: model_7 },
model_8: { namespace: 'Search.people.model', model: model_8 },
model_9: { namespace: 'Search.products.model', model: model_9 },
} as const
